import { render, staticRenderFns } from "./TrendingArticles.vue?vue&type=template&id=690dd499&scoped=true&"
import script from "./TrendingArticles.vue?vue&type=script&lang=js&"
export * from "./TrendingArticles.vue?vue&type=script&lang=js&"
import style0 from "./TrendingArticles.vue?vue&type=style&index=0&id=690dd499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690dd499",
  null
  
)

export default component.exports